import { Spinner } from '@gluestack-ui/themed'
import React, { FunctionComponent, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CityActions } from '../../redux/city/action'
import { townHallSelector } from '../../redux/city/selector'
import { RootState } from '../../redux/reducers'
import { Referentiel } from '../Referentiel'

interface TownHallProps {
  cityId: number
}
export const TownHall: FunctionComponent<TownHallProps> = ({ cityId }) => {
  const dispatch = useDispatch()
  const townHall = useSelector((state: RootState) => townHallSelector(state))

  useEffect(() => {
    dispatch(CityActions.loadTownHall(cityId))
  }, [])

  if (!townHall) {
    return <Spinner />
  }

  return <Referentiel id={townHall} />
}
